export default __webpack_public_path__ + "static/media/snack.cc4d2f19.svg";